import $ls, { LocalStorageKey } from "@/utils/local-storage";
import { useRoute, useRouter } from "vue-router";

export const useNavigate = () => {
  const route = useRoute();
  const router = useRouter();

  const storeBackPath = (customRoutePath?: string) => {
    $ls.setItem(LocalStorageKey.BACK_PATH, customRoutePath ?? route.fullPath);
  };

  const navigateCanva = (drawingId: number, customRoutePath?: string) => {
    storeBackPath(customRoutePath);
    router.push({
      name: "canvas",
      params: { drawingId },
    });
  };

  const navigateReport = (reportId: number, customRoutePath?: string) => {
    storeBackPath(customRoutePath);
    router.push({
      name: "report-tool",
      params: { reportId },
    });
  };

  const navigateFieldObservations = (
    diagnosticId: number,
    customRoutePath?: string
  ) => {
    storeBackPath(customRoutePath);
    router.push({
      name: "field-observations",
      params: { diagnosticId },
    });
  };

  const navigateDiagnostic = (diagnosticId: number) => {
    router.push({
      name: "diagnostic",
      params: { id: diagnosticId },
    });
  };

  return {
    navigateCanva,
    navigateReport,
    navigateFieldObservations,
    navigateDiagnostic,
  };
};
